import React, {useState} from 'react';
import moment from "moment/moment";
import {renderRegisterName, targetWeek} from "./aruanaKayarReviseRender";
import ReviseDocumentWrapper from "./reviseDocumentWrapper";
import CopyDownloadLink from "./CopyDownloadLink";
import UpdateRevise from "./updateRevise";
import AruanaKayarRender from "./AruanaKayarRender";
import SiteKayarRender from "./SiteKayarRender";

const SiteKayarReviseRender = ({ revise }) => {
  const [data, setData] = useState(JSON.parse(revise.dataJson))
  const [canSend, setCanSend] = useState(false)

  const [sendFiles, setSendFiles] = useState(revise.documents.map((u, index) => {
    u.registerName = renderRegisterName(u.name)
    return u}))
  const options = {
    targetWeek: targetWeek(+moment(revise.startDate).format('D')),
    targetMonth: +moment(revise.startDate).format('M'),
    targetYear:+moment(revise.startDate).format('YYYY'),
    url: "/api/racoon/pdfParse/checkKayarSite",
    reviseId:revise.id
  }
  return (
    <>
      <ReviseDocumentWrapper revise={revise} withoutFils>
        <UpdateRevise cb={(data, file) => {
          setData(data)
          file ? setSendFiles([file]) : setSendFiles([])
          setCanSend(true)
        }}
                      title={'Обновить информацию Сайт-Каяр из 1с'}
                      revComment={revise.comment}
                      data={data}
                      options={options}/>

      </ReviseDocumentWrapper>
      <SiteKayarRender data={data}/>

    </>
  );
};

export default SiteKayarReviseRender;